const pickChangedFields = require ('./pickChangedFields');
const _ = require('lodash');

module.exports = (angularModule) => {

  angularModule.directive('securityConfigEditor', () => {
    return {
      restrict: 'E',
      template: require('./securityConfigEditor.html'),
      scope: {
        model: '='
      }
    }
  })
};


function toHoursFromSeconds(seconds) {
  return seconds / 3600
}

function toMinutesFromSeconds(seconds) {
  return seconds / 60
}

function toSecondsFromHours(hours) {
  return hours * 3600
}

function toSecondsFromMinutes(minutes) {
  return minutes * 60
}

module.exports.fromConfig = (config) => {
  return {
    sessionDuration: toHoursFromSeconds(config.securityConfig.sessionDuration),
    inactivityTimeout: toMinutesFromSeconds(config.securityConfig.inactivityTimeout),
    passwordMinLength: config.securityConfig.passwordMinLength,
    lockoutPolicyAttemptsAllowed: config.securityConfig.lockoutPolicyAttemptsAllowed,
    lockoutPolicyDuration: toMinutesFromSeconds(config.securityConfig.lockoutPolicyDuration)
  }
}

module.exports.toConfig = (config) => {
  return {
    securityConfig: {
      sessionDuration: toSecondsFromHours(config.sessionDuration),
      inactivityTimeout: toSecondsFromMinutes(config.inactivityTimeout),
      passwordMinLength: config.passwordMinLength,
      lockoutPolicyAttemptsAllowed: config.lockoutPolicyAttemptsAllowed,
      lockoutPolicyDuration: toSecondsFromMinutes(config.lockoutPolicyDuration)
    }
  }
}

module.exports.sparsify = (before, after) => pickChangedFields(before, after);

